import { useQuery } from 'react-query';
import { fetchWeeklyTrending } from '../services/api';

export const useWeeklyTrending = options => {
  return useQuery('weeklyTrending', fetchWeeklyTrending, options);
};
